module.exports = __webpack_public_path__ + "static/lost-wax-casting-a053b13ff471747d7436f5f41b8a7750.png";